import { useAtomValue } from 'jotai';

import { stripeAtom } from './stripe.atoms';

const useLoadedStripe = () => {
  const stripe = useAtomValue(stripeAtom);

  return stripe;
};

export { useLoadedStripe };
